import React from 'react'
import CollegeFootball from 'src/components/page/college-football'
import { teamIds } from 'src/constants/personalizationIds'
export default (props) => (
  <CollegeFootball
    {...props}
    team="Colorado Buffaloes"
    subtitle="See the Colorado Buffaloes in action this season"
    hasGenericVideo={true}
    teamId={teamIds['Colorado Buffaloes']}
  />
)
